import Reveal from "@/components/base/Reveal";
import { socialAccounts, socialTips } from "@/mocks/siteContent";

export default function SocialSection() {
  return (
    <section id="social" className="scroll-mt-20 w-full bg-background-50">
      <div className="w-full px-4 md:px-8 lg:px-12 py-14 md:py-20">
        <Reveal>
          <div className="flex items-center gap-3 mb-3">
            <span className="h-px w-8 bg-secondary-500"></span>
            <span className="font-label text-xs md:text-sm tracking-widest text-secondary-700 uppercase">
              Social
            </span>
          </div>
          <h2 className="font-heading font-bold text-foreground-950 text-2xl md:text-4xl">
            ins 账号与社交平台线索
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base max-w-3xl leading-relaxed">
            「夏目彩春 ins」是搜索热度最高的关键词之一。下面整理了各平台上的公开线索与辨别思路，帮助你先判断真假再决定是否关注。
          </p>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 lg:grid-cols-12 gap-8">
          <Reveal className="lg:col-span-7">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {socialAccounts.map((a) => (
                <div
                  key={a.platform}
                  className="rounded-xl border border-background-200 bg-background-50 p-4 md:p-5"
                >
                  <div className="flex items-center justify-between">
                    <span className="w-10 h-10 rounded-full bg-secondary-100 text-secondary-900 flex items-center justify-center">
                      <i className={`${a.icon} text-xl`}></i>
                    </span>
                    <span className="text-[11px] px-2 py-0.5 rounded-full bg-background-200 text-foreground-700 font-label">
                      {a.state}
                    </span>
                  </div>
                  <h3 className="mt-3.5 text-sm md:text-base font-semibold text-foreground-950">
                    {a.platform}
                  </h3>
                  <p className="text-xs text-primary-600 mt-0.5 font-label">{a.status}</p>
                  <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed">
                    {a.detail}
                  </p>
                </div>
              ))}
            </div>
          </Reveal>

          <Reveal className="lg:col-span-5" delay={120}>
            <div className="w-full h-[220px] md:h-[260px] rounded-2xl overflow-hidden border border-background-200 bg-background-100 mb-5">
              <img
                src="https://readdy.ai/api/search-image?query=Stylized%20flat%20lay%20of%20a%20smartphone%20with%20social%20media%20app%20icons%2C%20soft%20pink%20and%20cream%20background%2C%20minimal%20artistic%20illustration%2C%20clean%20and%20modern%20aesthetic&width=800&height=800&seq=natsume-social-04&orientation=squarish"
                alt="社交账号辨别配图，手机与社交平台图标示意"
                title="夏目彩春 ins 账号辨别"
                className="w-full h-full object-cover object-top"
              />
            </div>

            <div className="rounded-2xl border border-background-200 bg-secondary-50 p-5">
              <h3 className="text-sm font-semibold text-secondary-900 flex items-center gap-2">
                <i className="ri-shield-keyhole-line"></i>
                辨别账号真伪的四个要点
              </h3>
              <ul className="mt-3.5 space-y-3">
                {socialTips.map((tip, i) => (
                  <li key={i} className="flex items-start gap-2.5">
                    <span className="w-5 h-5 shrink-0 rounded-full bg-secondary-500 text-background-50 text-[10px] flex items-center justify-center font-label mt-0.5">
                      {i + 1}
                    </span>
                    <span className="text-xs md:text-sm text-foreground-700 leading-relaxed">
                      {tip}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}